import React, { useState } from 'react';
import BsModal from '../Common/BsModal';
import TextInput from '../Common/TextInput';
import Notification from '../Common/Notification';
import ajaxGym from '../../util/remote/ajaxGym';

const NewClassModal = ({ show, onClose, onClassCreated }) => {
  const [className, setClassName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);

  const handleCreateClass = async () => {
    if (!className) {
      setNotify(<Notification type='danger' message='Class name is required' />);
      return;
    }

    setLoading(true);
    const server_response = await ajaxGym.createClass({
      class_name: className,
      description: description
    });
    setLoading(false);

    if (server_response.status === "OK") {
      setNotify(<Notification type='success' message={server_response.message} />);
      setClassName('');
      setDescription('');
      if (onClassCreated) onClassCreated();
      setTimeout(() => closeModal(), 1200);
    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);
    }
  };

  const closeModal = () => {
    setClassName('');
    setDescription('');
    setNotify(null);
    onClose();
  };

  return (
    <BsModal
      show={show}
      onClose={closeModal}
      title="Create New Class"
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={loading || !className || !description}
            onClick={handleCreateClass}
          >
            <i className="fa fa-plus-circle mr-1"></i> Create Class
          </button>
        </>
      }
    >
      <TextInput
        label="Class Name"
        placeholder="Enter class name"
        leftIcon="fa fa-dumbbell"
        value={className}
        onChange={e => setClassName(e.target.value)}
        required
      />
      <TextInput
        label="Description"
        placeholder="Description"
        leftIcon="fa fa-align-left"
        value={description}
        onChange={e => setDescription(e.target.value)}
      />

      {loading && <div className="mt-3"><i className="fa fa-spinner fa-spin"></i> Saving...</div>}
      {notify}
    </BsModal>
  );
};

export default NewClassModal;
